import { TriviaList } from '@repo/types'
import { Badge } from '@repo/ui'
import { ScrollContainer } from '@repo/ui/client'
import { observer } from 'mobx-react-lite'

import { List } from '@/components/List'
import { shuffle } from '@/utils/shuffle'

import { TriviaItemDisplay } from './TriviaItemDisplay'

interface TriviaListPreviewProps {
  triviaList: TriviaList
}

export const TriviaListPreview = observer(function TriviaListPreview({
  triviaList
}: TriviaListPreviewProps) {
  const displayedPlaylist = triviaList.disableShuffle
    ? triviaList.items
    : shuffle([...triviaList.items])

  return (
    <div className='flex flex-col overflow-hidden'>
      <h4 className='mb-4 mt-0 flex items-center'>
        <span className='text-muted mr-2'>Possible Questions:</span>{' '}
        <Badge size='small'>{triviaList.items.length}</Badge>
      </h4>

      <ScrollContainer className='border-shade-3 bg-shade-1 rounded-lg border'>
        <List className='border-0' tabIndex={0}>
          {displayedPlaylist.map(item => (
            <List.Item key={item.id} disableBorder>
              <TriviaItemDisplay item={item} />
            </List.Item>
          ))}
        </List>
      </ScrollContainer>
    </div>
  )
})
